import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import DocumentationSidebar from '../component/DocumentationSidebar';
import Searchbar from '../component/SearchBar';
import image001 from '../assetes/images/survey/dashboard-img/image001.png';
import image002 from '../assetes/images/survey/dashboard-img/image002.png';
import image003 from '../assetes/images/survey/dashboard-img/image003.png';
import image004 from '../assetes/images/survey/dashboard-img/image004.png';
import image008 from '../assetes/images/survey/dashboard-img/image008.png';


export default function Dashboard() {
  return (
    <>
      <div className='d-flex flex-column main-outer-wrapper'>
        <div className="flex-grow-1 d-flex survey-main-wrapper">
          <DocumentationSidebar />

          {/* Dashboard Content */}
          <div className="flex-grow-1 dashboard-page-outer">
            <div className='dashboard-page-wrap document-page-wrap'>
              <Searchbar containerSelector=".search-scope" />
              <div className='search-scope mt-4'>
                <h1 className='mt-0 text-primary'>Calculator List</h1>
                <p className='header-para'>
                  The Calculator module is designed to enable users to build and manage ROI (Return on Investment) calculators that demonstrate the business value or potential savings a customer can expect from using a specific product or solution.
                </p>

                <div className="card dashboard-card mb-4">
                  <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                    Navigating to Calculator

                  </div>
                  <div className="card-body">

                    <ul>

                      <li> Log in to your account.
                      </li>
                      <li>On the left sidebar, on successsful login user can redirect to Calculator List view.
                        Or else click on Calculator to access the calculator page.
                      </li>
                      <li>
                        <span>
                          The detail view of calculator is showns in the image
                          <img src={image001} alt="Navigate" className='img-fluid pt-20 pb-10' />
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="card dashboard-card mb-4">
                  <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                    Header Section
                  </div>
                  <div className="card-body">
                    <img src={image002} alt="Navigate" className='img-fluid pt-10 pb-20' />

                    <p><b>User Profile</b></p>
                    <ul>
                      <li>User Profile: Displays the logged-in user's name and email.</li>
                      <li>Dropdown Menu: Likely contains options to log out or change Profile settings.</li>
                    </ul>
                    <img src={image003} alt="Navigate" className='img-fluid  pb-20' />
                    <p><b>Breadcrumb</b></p>

                    <ul>
                      <li> In the List, the currently active page name is displayed on the right side of the layout,
                        This helps users quickly identify which section of the platform they are working on.
                      </li>
                    </ul>




                  </div>
                </div>

                <div className="card dashboard-card mb-4">
                  <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                    Filters and Buttons
                  </div>
                  <div className="card-body">
                    <p><b>Search Bar</b> - Users can search for a specific calculator by entering a keyword.</p>

                    <img src={image004} alt="Navigate" className='img-fluid  pb-30' />


                    <p><b>Create Button</b></p>

                    <ul>
                      <li> Located on the right side as a red button labeled + Create.</li>
                      <li>Allows users to create a new calculator quickly.</li>
                      <li>the detail we can see in next module i.e.
                        <NavLink to="/admin/ducumentation/surveys/create-calculator">
                          <span className="nav-text"> Create Calculator</span>
                        </NavLink>
                      </li>
                    </ul>

                    <p><b>Export Button</b></p>
                    <ul>
                      <li> Exports the ROI calculator data to Excel format.</li>
                    </ul>

                  </div>
                </div>

                <div className="card dashboard-card mb-4">
                  <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                    ROI Calculators Table
                  </div>
                  <div className="card-body">
                    <img src={image008} alt="Navigate" className='img-fluid pt-10 pb-10' />
                    <p>Each row in the table represents a unique ROI calculator with the following details:</p>
                    <ul>
                      <li> <b>ROI Name</b>  - Name of the ROI calculator </li>
                      <li><b>Share</b> - Share icon to share/copy the link of the calculator</li>
                      <li><b>Reports Generated</b> - Number of reports generated from that calculator (e.g., 0)</li>
                      <li><b>Created By</b> - The user who created the calculator</li>
                      <li><b>Countries</b> - The region or country it's associated with (e.g., United States)</li>
                      <li><b>Status</b> - Publication status (e.g., Publish)</li>
                      <li><b>Languages</b> - Language in which the calculator is available (e.g., English)</li>
                      <li><b>Actions</b> - This column contains  various actions that can be performed on
                        each calculator. The detail explaintions is provinded in <b>

                          <NavLink to="/admin/ducumentation/surveys/document-actionsinlist">
                            <span className="nav-text"> Action in calculator list </span>
                          </NavLink></b> page</li>
                    </ul>

                  </div>
                </div>

              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  )
}
